import SystemDialog from './SystemDialog';
import Theme from './Theme';
import SystemToast from './SystemToast';
import GenericDelete from './GenericDelete';
import GridDialog from './GridDialog';
import Comment from './Comment';
import AppNotifications from './AppNotifications';
import RestrictUserInvoices from './RestrictUserInvoices';
import NewInventory from './NewInventory';
const helpers = {
  theme: Theme,
  systemToast: SystemToast,
  systemDialog: SystemDialog,
  genericDelete: GenericDelete,
  gridDialog: GridDialog,
  comment: Comment,
  appNotifications: AppNotifications,
  restrictInvoices: RestrictUserInvoices,
  newInventory: NewInventory,
};
export default helpers;
